<svelte:options customElement={{
	tag: "viz-bt-universe-history",
	shadow: "none"
 }} />

<script lang="javascript">
	import {onMount} from 'svelte';
	import { fade } from 'svelte/transition';
	import { createLoadObserver } from "../../utils/utils.js";
	
	// ToDo: load in external image and then fade in
	import PointOfInterest from "./PointOfInterest.svelte";
	import { selectedPostData } from "../../stores/stores.js";
	import Modal from "./Modal.svelte";

	export let postDataId = undefined;
	export let postDataJson = undefined;
	export let bgImagePath;
	export let bgImagePath2;
	export let bgImageSVG;
	export let positionDataPerPostIdJson = undefined;
	export let aspectRatio = undefined;

	let version = "0.0.4";
	let postData = undefined;
	let positionDataPerPostId = undefined;
	let bgImagesLoaded = false;
	let bgImage1Loaded = false;
	let bgImage2Loaded = false;

	$: bgClasses = bgImagesLoaded ? 'opacity-100' : 'opacity-0';
	$: showModal = $selectedPostData !== undefined;
	$: document.body.classList.toggle('scroll-lock', showModal); // lock the scroll when modal is open
	$: styles = aspectRatio ? `aspect-ratio: ${aspectRatio}` : '';
	$: useAspectRatio = aspectRatio ? true : false;

	// if postDataJson is provided, use it
	if (postDataJson) {
		postData = JSON.parse(postDataJson);
	}

	// if no postData but there's a postDataId and window.visualizationData, use it
	// window.visualizationData may contain the collection data we're looking for
	if (!postData && postDataId && window.visualizationData && window.visualizationData[postDataId] && window.visualizationData[postDataId].items) {
		postData = window.visualizationData[postDataId];
	}

	// set up position data per post id
	if (!positionDataPerPostId && positionDataPerPostIdJson) {
		positionDataPerPostId = JSON.parse(positionDataPerPostIdJson);
	}

	const isProd = () => {
		return location.hostname == "bigthink.com";
	}

	const onload1 = createLoadObserver(() => {
		bgImage1Loaded = true;
		checkImageLoaded();
    })

	const onload2 = createLoadObserver(() => {
		bgImage2Loaded = true;
		checkImageLoaded();
    })

	const getPositionPerId = (id) => {
		if (positionDataPerPostId && positionDataPerPostId[id]) {
			return positionDataPerPostId[id];
		}
		return {
			"x": Math.random(),
			"y": Math.random()
		};
	};

	const onTouchPointOfInterest = (data) => {
		console.log('onTouchPointOfInterest', data);
		selectedPostData.set(data);
	}

	const handleModalClose = () => {
		selectedPostData.set(undefined);
	}

	/**
	 * Check if all images are loaded
	 */
	const checkImageLoaded = () => {
		let loaded = false;
		if (bgImagePath && bgImagePath2) {
			// if we have to get both images
			if (bgImage1Loaded && bgImage2Loaded) {
				loaded = true;
			}
		} else if (bgImagePath){
			// if we only have one image
			if (bgImage1Loaded) {
				loaded = true;
			}
		} else if (bgImagePath2) {
			// if we only have the second image
			if (bgImage2Loaded) {
				loaded = true;
			}
		}
		bgImagesLoaded = loaded;
	}

	onMount(async () => {
		if (!isProd()) {
			console.info("viz-bt-universe-history version ", version);
			console.info("postDataId", postDataId);
			console.info("postDataJson", postDataJson);
			console.info("positionDataPerPostIdJson", positionDataPerPostIdJson);
			console.info("window.visualizationData", window.visualizationData);
		}

		if (!positionDataPerPostId) {
			if (!isProd()) {
				console.info("positionDataPerPostId is missing");
			}
		}

		if (!postDataJson) {
			if (!isProd()) {
				console.info("postDataJson is missing");
			}
		}
		// no remote images at all
		if (!bgImagePath) {
			bgImagesLoaded = true;
		}
    });

</script>

<div class="viz w-full relative" style={styles}>
	<div class="w-full h-full relative transition-opacity {bgClasses}" >
		{#if bgImagePath}
			<img use:onload1 class="z-[1] top-0 bottom-0 w-full h-full {useAspectRatio ? 'absolute' : 'relative'}" src={bgImagePath} alt="" />
		{/if}
		{#if bgImagePath2}
			<img use:onload2 class="z-[2] absolute top-0 bottom-0 w-full h-full" src={bgImagePath2} alt="" />
		{/if}
		{#if bgImageSVG}
			<div class="absolute top-0 left-0 w-full h-full" >
				{@html bgImageSVG}
			</div>
		{/if}
	</div>
	{#if postData && postData.items}
		<div class="absolute z-10 top-0 left-0 w-full h-full">
			{#each postData.items as item}
				<PointOfInterest handlePOITouch={onTouchPointOfInterest} positionObject={getPositionPerId(item.id)} postData={item} />
			{/each}
		</div>
	{/if}
	{#if showModal}
		<Modal title={$selectedPostData.title} thumbnailPath={$selectedPostData.image} excerpt={$selectedPostData.excerpt} url={$selectedPostData.url} onClose={handleModalClose} />
	{/if}
</div>

<style>
	/* for locking the scroll */
    :global(.scroll-lock) {
		overflow-y: hidden;
	}
</style>
